var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.159,
    height: 23.123,
    viewBox: "0 0 24.159 23.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M12.225.8,9.276,6.782l-6.6.962a1.446,1.446,0,0,0-.8,2.466l4.773,4.651-1.129,6.57a1.444,1.444,0,0,0,2.1,1.522l5.9-3.1,5.9,3.1a1.445,1.445,0,0,0,2.1-1.522l-1.129-6.57,4.773-4.651a1.446,1.446,0,0,0-.8-2.466l-6.6-.962L14.817.8a1.446,1.446,0,0,0-2.592,0Z",
    transform: "translate(-1.441 0.001)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarInactive);
export default __webpack_public_path__ + "static/media/starInactive.d9043e5b259ed78962ccbdab14f70642.svg";
export { ForwardRef as ReactComponent };